import Overlay from './overlay';

export default new Overlay('overlay', 'overlay');
